import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import adminCrmService from '../../services/adminCrmService';

const CrmSessionAdminContext = createContext(null);


export const CrmSessionAdminProvider = ({ children }) => {
  const [sessionActive, setSessionActive] = useState(false);
  const targetUserIdRef = useRef(null);
  const portalWindowRef = useRef(null);

  const beginSession = useCallback((targetUserId, portalWindow) => {
    targetUserIdRef.current = targetUserId;
    portalWindowRef.current = portalWindow;
    setSessionActive(true);
  }, []);

  const finishSession = useCallback(async () => {
    // 1. Force-close the portal tab (works because we opened it via window.open)
    try {
      if (portalWindowRef.current && !portalWindowRef.current.closed) {
        portalWindowRef.current.close();
      }
    } catch (e) {}

    // 2. Call backend to invalidate the session token
    const uid = targetUserIdRef.current;
    try {
      if (uid) await adminCrmService.endSession(uid);
    } catch (e) {}

    setSessionActive(false);
    targetUserIdRef.current = null;
    portalWindowRef.current = null;
  }, []);

  return (
    <CrmSessionAdminContext.Provider value={{ sessionActive, beginSession, finishSession }}>
      {children}
      {sessionActive && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.65)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(4px)',
        }}>
          <div style={{ color: '#fff', fontSize: 28, fontWeight: 700, marginBottom: 12 }}>
            CRM in Progress
          </div>
          <div style={{ color: '#ccc', fontSize: 14, marginBottom: 28 }}>
            A CRM session is active in another tab
          </div>
          <button
            onClick={finishSession}
            style={{
              backgroundColor: '#FF3B30',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 28px',
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            End Session
          </button>
        </div>
      )}
    </CrmSessionAdminContext.Provider>
  );
};

export const useCrmSession = () => useContext(CrmSessionAdminContext);
export default CrmSessionAdminContext;
